import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-toggle-left-icon',
  templateUrl: './text-toggle-left.component.html'
})
export class TextToggleLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
